<template>
    <div id="app">
        <div class="content">
            <client-only>
                <Header v-if="$device.isDesktop" />
                <HeaderMobile v-else />
                <!--            <NotifyVPN></NotifyVPN>-->
                <div class="sub-header" v-if="showCrumbs">
                    <div class="container">
                        <breadcrumbs />
                    </div>
                </div>
            </client-only>
            <div class="page">
                <div class="page__content text_13">
                    <div class="page__title" v-if="$device.isDesktop">
                        {{ $t("lk") }}
                        <div v-if="$auth.loggedIn" class="like-link text_11" @click="logout()">{{ $t("logout") }}</div>
                    </div>
                    <div class="page__title" v-else @click="$nuxt.$emit('show-user-popup')">
                        <svg-icon name="user" width="32" height="32"></svg-icon>
                        <div class="user-name text_11" v-if="$auth.loggedIn">{{ $auth.user.name }}</div>
                        <svg-icon name="arrow-down" width="8" height="8" />
                    </div>
                    <div class="lk">
                        <div class="row flex-row row--fullwidth">
                            <div class="col lg-3 col--no-padding" v-if="$device.isDesktop">
                                <div class="lk-sidebar">
                                    <div class="lk-sidebar__content">
                                        <LkLinks v-if="$auth.loggedIn"></LkLinks>
                                    </div>
                                    <div class="lk-sidebar__footer text_11">
                                        <PPSCallBack />
                                    </div>
                                </div>
                            </div>
                            <div class="col col--no-padding" :class="$device.isDesktop ? 'lg-9' : 'lg-12'">
                                <nuxt />
                                <div class="lk-sidebar" v-if="!$device.isDesktop">
                                    <div class="lk-sidebar__footer text_11">
                                        <PPSCallBack />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <client-only>
            <!--        <EnRecom></EnRecom>-->
            <NotifyModal />
            <!--        <EnRecom v-if="$i18n.locale === 'ru'"></EnRecom>-->
            <SupportWidget />
            <SubscribePopup2 />
            <CookiesModal />
            <!--        <CountryModal/>-->
        </client-only>
    </div>
</template>
<script>
import Header from "@/components/Header.vue";
import HeaderMobile from "@/components/HeaderMobile.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import LkLinks from "@/components/LkLinks";
import PPSCallBack from "@/components/PPSCallBack";
import NotifyModal from "@/components/NotifyModal.vue";
// import CountryModal from "@/components/CountryModal.vue";
import SupportWidget from "../components/ui/SupportWidget.vue";
// import NotifyVPN from "../components/NotifyVPN.vue";
import SubscribePopup2 from "@/components/ui/SubscribePopup2.vue";
import CookiesModal from "@/components/ui/CookiesModal.vue";
export default {
    name: "App",
    components: {
        SubscribePopup2,
        SupportWidget,
        // NotifyVPN,
        Header,
        HeaderMobile,
        Breadcrumbs,
        LkLinks,
        PPSCallBack,
        NotifyModal,
        CookiesModal,
        // CountryModal
    },
    data() {
        return {
            isMac: false,
        };
    },
    computed: {
        bodyClass() {
            let bodyClass = this.$device.isDesktop ? "is_desktop" : "is_mobile";
            bodyClass += this.isMac ? " is_apple" : "";
            bodyClass += " page-" + this.$route.name;
            bodyClass += this.showCrumbs ? "" : " no-subheader";

            return bodyClass;
        },
        showCrumbs() {
            return this.$device.isDesktop && this.$route.name !== "index";
        },
    },
    head() {
        return {
            meta: [{ rel: "canonical", href: "https://post-post-scriptum.com" + this.$route.path }],
            bodyAttrs: {
                class: this.bodyClass,
            },
        };
    },
    watch: {
        $device() {
            if (this.$device.isIos || this.$device.isMacOS) this.isMac = true;
        },
    },
    methods: {
        async logout() {
            await this.$auth.logout();
            sessionStorage.removeItem("storedOrderData");
            // window.location.reload();
        },
    },
    mounted() {
        if (this.$device.isDesktop) {
            document.querySelector("body").style.setProperty("--footer-height", 0 + "px");
        }
    },
};
</script>
<style lang="less">
.page {
    &__title {
        position: relative;
        .user-name {
            margin: 0 4px;
            text-decoration: underline;
        }
        .like-link {
            position: absolute;
            right: 32px;
            top: 50%;
            margin-top: -7px;
            border-bottom: 1px solid;
        }
    }
}
.lk {
    &-sidebar {
        display: flex;
        flex-direction: column;
        background: #fff;
        padding: 32px;
        height: 100%;
        border-right: 1px solid @border2;
        margin-right: -1px;
        min-height: calc(100dvh - 110px);
        position: relative;
        z-index: 4;
        @media @sm {
            padding: 40px 16px 24px;
            margin-right: 0;
            border-right: 0;
            background: @bg;
            border-top: 1px solid @border2;
            min-height: auto;
        }
        &__content {
            margin-bottom: 40px;
            flex-grow: 1;
            a {
                line-height: 32px;
            }
            @media (max-height: 685px) {
                flex-grow: initial;
            }
        }
        &__footer {
            position: sticky;
            bottom: 32px;
            @media (max-height: 685px) {
                position: relative;
            }
        }
    }
    &-content {
        &__title {
            padding: 32px;
            border-bottom: 1px solid @border2;
            @media @sm {
                padding: 24px 16px;
            }
            .text_15 {
                margin-bottom: 16px;
            }
        }
        &__section {
            padding: 32px;
            height: 410px;
            display: flex;
            flex-direction: column;
            border-right: 1px solid @border2;
            @media @sm {
                height: auto;
                padding: 24px 16px;
                position: relative;
                border-left: 0;
                border-bottom: 1px solid @border2;
            }
            @media @notsm {
                &:hover {
                    background: @border2;
                }
            }
            svg {
                margin-top: auto;
                @media @sm {
                    position: absolute;
                    top: 24px;
                    right: 24px;
                }
            }
            .text_15 {
                margin-bottom: 16px;
            }
        }
        &__body {
            padding: 32px;
        }
    }
    &-page {
        padding: 32px;
        @media @sm {
            padding: 24px 16px 40px;
        }
    }
}
</style>
